export const FOOD_BOX = {
  headingLine1: 'What is a Gousto Food box?',
  altText: 'Open Gousto recipe box neatly packed with vegetables, meat, spices, and recipe cards.',
  ctaText: 'Try Gousto with 50% off',
}
